export class ConfirmerProfessionnelItem 
{
    professionnelItemId: number|undefined;
    montantAccorde: number;
    tauxAccorde: number;
    echeanceAccorde: number;
    commissionEngagementAccorde: number;
    typeTirage: String;
}